import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { ActionCreator } from '@types'
import { IPages } from '../models'
import * as TYPES from '../actionTypes'

export const initialState: IPages = fromJS({
  home: {},
})

export const pagesReducer: Reducer<IPages, ActionCreator> = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.SET:
      return state.merge(payload)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', payload)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    case TYPES.CONTENT.REQUEST:
      return state.set('loading', true)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(payload)
    default:
      return state
  }
}
